
  import { Icon } from '@/ui/components/icon/Icon';
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'CollapseIcon',
    components: {
      Icon,
    },
    props: {
      rotation: {
        type: Number,
        default: 0,
      },
    },
  });
